module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    attrs: {
      "id": "alert-box"
    }
  }, [_c('div', {
    staticClass: "alert-box-head"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Welcome to the Our Air Video Challenge!")]), _vm._v(" "), _c('div', {
    staticClass: "alert-button"
  }, [_c('a', {
    staticClass: "btn btn-draft",
    attrs: {
      "role": "button",
      "href": "http://drishtiair.com/video-challenge",
      "target": "_blank"
    }
  }, [_vm._v("Know More")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c409edec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoChallenge.vue
// module id = 312
// module chunks = 1